/**
 * @Description Reducer for business card rules
 * @FileName businessCardRulesReducer.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 29 January, 2021 04:15:36
 * @IssueID - Issue IDs
 */

import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { ppDetailActionTypes } from '../actions/actionTypes';

export const REDUCER_NAME = 'DefaultPpFilterList';

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault || null,
      systemDefaultFilter: action.data.systemDefault || null,

    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      userDefaultFilter: action.data.userDefault,
      selectedFilter: action.data.selectedItem || null,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const updateFilterOption = (state, action) => ({
  ...state,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  selectedFilter: action.data ? action.data : null,
});

const logBcrListRequest = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});
const toggleOptn = (action) => ({
  enableApprove: action.data.enableApprove,
});
const defaultCompStructFilterList1 = (state, action = null) => {
  switch (action.type) {
    case ppDetailActionTypes.UPDATE_PP_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case ppDetailActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case ppDetailActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateFilterOption(state, action);
    case ppDetailActionTypes.LOG_COMPCAL_LIST_REQUEST:
      return logBcrListRequest(state, action);
    case ppDetailActionTypes.GET_DEFAULT_CS_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case ppDetailActionTypes.GET_CS_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case ppDetailActionTypes.GET_PP_STRUCTURE_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case ppDetailActionTypes.PP_JOB_REQUEST_RESPONSE: {
      return {
        ...state,
        jobRequestResponse: action.data,
      };
    }
    default:
      return null;
  }
};
const defaultCompStructFilterList2 = (state, action = null) => {
  switch (action.type) {
    case ppDetailActionTypes.RESET_CS_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case ppDetailActionTypes.TOGGLE_LIST_APPROVE_BUTTON:
      return toggleOptn(action);
    case ppDetailActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case ppDetailActionTypes.ENABLE_PP_APPROVE:
      return {
        ...state,
        enableApprove: action.data,
      };
    case ppDetailActionTypes.PP_JOB_RESET_REQUEST_RESPONSE: {
      return {
        ...state,
        jobRequestResponse: null,
      };
    }
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
};
const defaultCompStructFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const defaultCompStruct1 = defaultCompStructFilterList1(state, action);
  if (defaultCompStruct1 !== null) {
    return defaultCompStruct1;
  }
  const defaultCompStruct2 = defaultCompStructFilterList2(state, action);
  if (defaultCompStruct2 !== null) {
    return defaultCompStruct2;
  }
  return state;
};

export default defaultCompStructFilterList;
